<template src="../templates/cattle.pug" lang="pug"></template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { format, parse } from 'date-fns'
import differenceInYears from 'date-fns/difference_in_years'
import differenceInMonths from 'date-fns/difference_in_months'
import _filter from 'lodash/filter'
import _orderBy from 'lodash/orderBy'
import _forEach from 'lodash/forEach'
import _find from 'lodash/find'
import BuildingForm from './form/BuildingForm'
import AnimalForm from './form/AnimalForm'
import AnimalCard from './card/AnimalCard'

export default {
    name: 'Cattle',
    components: {
        BuildingForm,
        AnimalForm,
        AnimalCard
    },
    data() {
        return {
            searchInput: '',
            selectedAnimal: null,
            format
        }
    },
    computed: {
        ...mapGetters([
            'animals',
            'cattleLoading',
            'selectedFarm',
            'farmAnimalType',
            'countAnimalByType',
            'countAnimalByBuilding',
            'filteredFarmAnimals',
            'filterCowTypes',
            'isUserVisitor',
            'isColumnOrdered',
            'sicknessList'
        ]),
        filteredAnimals() {
            if (this.searchInput.length > 0) {
                let self = this
                return _filter(this.animals, function(a) {
                    let str = a.buckleNumber.toString()
                    return str.includes(self.searchInput)
                })
            } else {
                return this.filteredFarmAnimals
            }
        }
    },
    methods: {
        ...mapMutations([
            'updateFilterType',
            'setFilterBuildings',
            'resetFilterType',
            'selectFarm',
            'updateTableOrder'
        ]),
        ...mapActions(['deleteAnimal']),
        getAge(birthday) {
            let years = differenceInYears(Date.now(), new Date(birthday * 1000))
            let months = differenceInMonths(parse(Date.now()), new Date(birthday * 1000))
            let age = ''
            if (years > 0) {
                age += years + ' years '
            }
            if (months - years * 12 > 0) {
                age += months - years * 12 + ' months'
            }
            if (months === 0) {
                age += 'less than 1 months'
            }
            return age
        },
        getBuildingName(buildingId) {
            return _filter(this.selectedFarm.buildings, function(b) {
                return b.id === buildingId
            })[0]['name']
        },
        getSicknesses(sicknesses) {
            let res = ""
            let self = this
            _forEach(_orderBy(_filter(sicknesses, ['onGoing', true]), function (sickness) {return sickness.date}), function(s, i) {
                  if (i < 2) {
                      let sicknessInfo = _find(self.sicknessList, ['name', s.sickness])
                      res += window.navigator.language
                              ? sicknessInfo['name_' + window.navigator.language.substring(0,2)]
                              : sicknessInfo['name_ru'] + ' '
                  }
            })
            return res
        },
        deleteAnimalDialog(animal) {
            this.$dialog
                .confirm(this.$t('cattle.dialog.message', { buckle: animal.buckleNumber }), {
                    okText: this.$t('button.true'),
                    cancelText: this.$t('button.false')
                })
                .then(() => {
                    this.deleteAnimal(animal)
                })
                .catch(() => {})
        },
        goToAnimalUpdate(animal) {
            this.$router.push({
                name: 'edit-animal-form',
                params: {
                    animalId: animal.id,
                    animalToUpdate: {
                        id: animal.id,
                        birthday: animal.birthday,
                        buckleNumber: animal.buckleNumber,
                        building: animal.building,
                        type: animal.type,
                        isBought: animal.isBought,
                        father: animal.father,
                        mother: animal.mother,
                        prevalenceSickness: animal.prevalenceSickness
                    }
                }
            })
        },
        goToBuildingUpdate(building) {
            this.$router.push({
                name: 'edit-building-form',
                params: {
                    buildingId: building.id,
                    buildingToUpdate: {
                        id: building.id,
                        farmId: this.selectedFarm,
                        name: building.name,
                        maximumCapacity: building.maximumCapacity,
                        type: building.type
                    }
                }
            })
        },
        goToSicknessUpdate(animal) {
            this.$router.push({
                name: 'edit-sicknesses-form',
                params: {
                    animalId: animal.id,
                    sickAnimal: {
                        id: animal.id,
                        buckleNumber: animal.buckleNumber,
                        sicknesses: _filter(animal.sicknesses, ['onGoing', true])
                    }
                }
            })
        },
        goToMoveAnimal(animal) {
            this.$router.push({
                name: 'move-animal-form',
                params: {
                    animalId: animal.id,
                    animalToMove: {
                        id: animal.id,
                        building: animal.building,
                        buckleNumber: animal.buckleNumber
                    }
                }
            })
        }
    }
}
</script>

<style lang="sass" scoped>
    @import '../sass/mixin/color'
    @import '../sass/mixin/flex'

    #cattle
        .filter-container
            .filters-list
                .filter-building
                    background-color: $dd-lime-green
                .filter-type
                    background-color: $dd-soft-pink
        .content
            .button-row
                .round-button-effect
                    padding: 1em
                    .round-button-icon
                        fill: $dd-very-dark-gray
                        box-shadow: 0 0 0 4px $dd-very-dark-gray
                    &:hover
                        svg
                            background: $dd-very-dark-gray none repeat scroll 0 0
                            fill: white
            .cell-buckle-number
                cursor: pointer
                &:hover
                    font-size: 18px
                    font-weight: bold
                    color: $dd-light-orange

        .table-header
            background-color: $dd-very-dark-gray
</style>
